import React, { useEffect, useState } from "react";
import { getCurrentDate } from "../../../../Utilitie";

const HistoryForm = ({
  mode = "add",
  history = null,
  defaultStatus = "",
  currentStatus = [],
  onSubmit,
  onCancel,
  loading = false,
}) => {
  const [form, setForm] = useState({
    status_stage: "",
    action_date: "",
    remarks: "",
    document: null,
  });

  useEffect(() => {
    if (mode === "edit" && history) {
      setForm({
        status_stage: history.status_stage || "",
        action_date: history.action_date
          ? String(history.action_date).slice(0, 10)
          : "",
        remarks: history.remarks || "",
        document: null,
      });
    } else {
      setForm({
        status_stage: defaultStatus || "",
        action_date: new Date().toISOString().slice(0, 10),
        remarks: "",
        document: null,
      });
    }
  }, [mode, history, defaultStatus]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setForm((prev) => ({ ...prev, document: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.status_stage || !form.action_date) return;
    await onSubmit(form);
  };

  // Keep the order supplied by ProcurementHistory; do not alphabetically sort.
  const orderedStatus = currentStatus;

  return (
    <form onSubmit={handleSubmit} className="border rounded p-3 mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-bold mb-0">
          {mode === "edit" ? "Edit History" : "Add History"}
        </h6>
        {mode === "edit" && <span className="badge bg-primary">Editing</span>}
      </div>

      <div className="row g-3">
        <div className="col-md-4">
          <label className="form-label fw-semibold">
            Status / Stage <span className="text-danger">*</span>
          </label>
          <select
            name="status_stage"
            value={form.status_stage}
            onChange={handleChange}
            className="form-select"
            required
            disabled={loading}
          >
            <option value="">Select Stage</option>
            {orderedStatus.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label className="form-label fw-semibold">
            Action Date <span className="text-danger">*</span>
          </label>
          <input
            type="date"
            name="action_date"
            value={form.action_date}
            onChange={handleChange}
            className="form-control"
            max={getCurrentDate()}
            required
            disabled={loading}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label fw-semibold">Document</label>
          <input
            type="file"
            className="form-control"
            accept=".pdf"
            onChange={handleFileChange}
            disabled={loading}
          />
          {form.document && (
            <div className="small text-muted mt-1">
              Selected: <strong>{form.document.name}</strong>
            </div>
          )}
        </div>

        <div className="col-12">
          <label className="form-label fw-semibold">Remarks</label>
          <textarea
            name="remarks"
            value={form.remarks}
            onChange={handleChange}
            className="form-control"
            rows="3"
            placeholder="Enter remarks..."
            disabled={loading}
          />
        </div>

        <div className="col-12 d-flex justify-content-end gap-2">
          {mode === "edit" && (
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
          )}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Saving...
              </>
            ) : mode === "edit" ? (
              "Save Changes"
            ) : (
              "Save History"
            )}
          </button>
        </div>
      </div>
    </form>
  );
};

export default HistoryForm;
